import { observer } from 'mobx-react-lite';

import { IcLinkIcon, IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

import { MetaBlock } from '../MetaBlock/MetaBlock';
import styles from './styles.m.css';

const InviteLink = ({ className, deepLink, metaBlockRef, Actions }) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard(deepLink, t('common_link_copied'));

  return (
    <MetaBlock
      className={className}
      label={t('common_invite_link')}
      containerRef={metaBlockRef}
      Icon={IcLinkIcon}
      Actions={
        <>
          {Actions}
          <IconButton
            Icon={IcSCopyIcon}
            onClick={copyToClipboard}
          />
        </>
      }
    >
      <button
        className={styles.link}
        onClick={copyToClipboard}
        data-test="invite-link"
      >
        {deepLink}
      </button>
    </MetaBlock>
  );
};

export default observer(InviteLink);
